import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Flex, Grid, useColorModeValue } from '@chakra-ui/react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { FaBackspace } from 'react-icons/fa';
import Header from '../components/Header';
import BgCharged from '../assets/img/BgCharged.png';
import forta from '../assets/img/avatars/forta.png';
import ProviderParams from '../components/ProviderParams';

export function PartnerDetails(getAction) {
  const bgProfile = useColorModeValue(
    'hsla(0,0%,100%,.8)',
    'linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)'
  );
  const { id, name, login } = useParams();
  const token = useAuthHeader();
  const [action, setAction] = useState(false);
  const [result, setResult] = useState([]);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    setAction(getAction);
  }, [getAction]);

  useEffect(() => {
    if (action) {
      let active = true;
      const getResult = async () => {
        if (active) {
          const result = await fetchData(id, token());
          if (result?.[0]) {
          } else {
            result[0] = { id: id, message: 'Нет подключенных терминалов' };
          }

          setResult(result);
          return () => {
            active = false;
          };
        }
      };

      const balance = async () => {
        if (active) {
          const res = await getBalance(id, token());
          setBalance(res);
          return () => {
            active = false;
          };
        }
      };

      getResult().then();
      balance().then();
      return () => {
        active = false;
      };
    }
  }, [action]);

  return (
    <Flex flexDirection="column" pt={{ base: '120px', md: '75px' }}>
      <Header
        BackUrl={'/admin_area/partners'}
        backgroundHeader={BgCharged}
        backgroundProfile={bgProfile}
        avatarImage={forta}
        name={name}
        email={[login, '  ( balance: ', balance, ' )']}
        tabs={[
          {
            name: 'Back',
            icon: <FaBackspace w="100%" h="100%" />,
          },
        ]}
      />
      <Grid templateColumns={{ sm: '1fr', xl: 'repeat(2, 1fr)' }} gap="22px">
        {result.map((row, id) => {
          return (
            <ProviderParams
              key={id}
              id={row.id}
              title={`Id ${row.id} - ${row.type} (${row.env})`}
              params={<pre>{JSON.stringify(row, null, 2)}</pre>}
            />
          );
        })}
      </Grid>
    </Flex>
  );

  async function fetchData(id = 1, token) {
    const response = await axios.get(`/api/v1/terminal?partner_id=${id}`, {
      headers: { Authorization: token },
    });
    return await response.data;
  }

  async function getBalance(id = 1, token) {
    const response = await axios.get(`/api/v1/wallet`, {
      headers: { Authorization: token },
    });
    const wallets = await response.data?.data;
    let balance = 0;
    for (let i = 0; i < wallets.length; i++) {
      if (wallets[i].partner_id === Number(id)) {
        balance += wallets[i].balance;
      }
    }
    return balance;
  }
}
